/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgNoteDelete
 */
export interface OrgNoteDelete {
    /**
     * 
     * @type {string}
     * @memberof OrgNoteDelete
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgNoteDelete
     */
    org_note_azure_id: string;
}

/**
 * Check if a given object implements the OrgNoteDelete interface.
 */
export function instanceOfOrgNoteDelete(value: object): value is OrgNoteDelete {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('org_note_azure_id' in value) || value['org_note_azure_id'] === undefined) return false;
    return true;
}

export function OrgNoteDeleteFromJSON(json: any): OrgNoteDelete {
    return OrgNoteDeleteFromJSONTyped(json, false);
}

export function OrgNoteDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgNoteDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'org_note_azure_id': json['org_note_azure_id'],
    };
}

export function OrgNoteDeleteToJSON(json: any): OrgNoteDelete {
    return OrgNoteDeleteToJSONTyped(json, false);
}

export function OrgNoteDeleteToJSONTyped(value?: OrgNoteDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'org_note_azure_id': value['org_note_azure_id'],
    };
}

